import { Globe } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = ({ changeLanguage, currentLang }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const isRtl = t('dir') === 'rtl';

    // Close dropdown on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Map language codes to labels
    const languages = [
        { code: "ar", label: "العربية", },//icon: "🇸🇦" },
        { code: "en", label: "English", },// icon: "🇺🇸" },
        { code: "he", label: "עברית", }//icon: "🇮🇱" },
    ];

    const selectedLang = languages.find((l) => l.code === currentLang);
    const sideDir = isRtl ? 'left-0' : 'right-0';
    
    return (
        <div
            ref={dropdownRef}
            dir={t("dir")}
            className="relative inline-block text-left"
        >
            {/* Trigger */}
            <button
                onClick={() => setOpen(!open)}
                className="w-12 h-10 rounded-full flex items-center justify-center
                   hover:bg-white/10 hover:text-accent transition-colors"
                aria-haspopup="true"
                aria-expanded={open}
            >
                <Globe className="w-5 h-5" />
                <span className="sr-only">Toggle language</span>
            </button>

            {/* Menu */}
            {open && (
                <div
                    className="absolute right-0 mt-2 w-40 rounded-md shadow-lg
                     bg-white ring-1 ring-black ring-opacity-5 z-50"
                    role="menu"
                >
                    <div className="py-1">
                        {languages.map(({ code, label, icon }) => (
                            <button
                                key={code}
                                onClick={() => {
                                    changeLanguage(code);
                                    setOpen(false);
                                }}
                                className={`
                  flex items-center w-full px-4 py-2 text-sm text-left
                  hover:bg-accent/20
                  ${selectedLang?.code === code ? "font-bold bg-accent/20" : ""}
                `}
                                role="menuitem"
                            >
                                <span className="mr-2">{icon}</span>
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
